'use strict';

require('./CompanyPublicationService');

function CompanyPublicationsListDraftsCtrl(
  $scope,
  $stateParams,
  $state,
  publications,
  currentCategory,
  priorities,
  translations
) {
  var i;
  $scope.publications = publications;
  $scope.$state = $state;
  $scope.priorityId = $stateParams.priorityId || null;
  $scope.selectedPriority = null;
  $scope.more = false;
  $scope.currentCategory = currentCategory;
  $scope.title = translations['publication.drafts'];

  if (currentCategory && currentCategory.name) {
    $scope.title = currentCategory.name;
  }

  if($scope.publications.length === 21) {
    $scope.more = true;
    $scope.publications.pop();
  }

  $scope.priorities = priorities;

  priorities.$promise.then(function() {
    for (i = 0; i < priorities.length; i++) {
      if(priorities[i].id === $scope.priorityId) {
        $scope.selectedPriority = priorities[i];
      }
      $scope.priorities[priorities[i].id] = priorities[i];
    }
  });

  $scope.page = $stateParams.page|0;
  $scope.companyId = $stateParams.companyId;
  $scope.listDrafts = true;

}

CompanyPublicationsListDraftsCtrl.resolve = {
  publications: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    var companyId = $stateParams.companyId,
    filter = {};

    if ('' !== $stateParams.priorityId) {
      filter.priorityId = $stateParams.priorityId;
    }
    filter.companyId = companyId;
    // Fetch 21 for pagination, but the offset should be using 20
    filter.limit = 21;
    filter.offset = ($stateParams.page|0) * 20;

    return CompanyPublicationService.queryDrafts(filter).$promise;
  }],
  priorities: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
    return CompanyService.queryPriorities({companyId: $stateParams.companyId});
  }],
  currentCategory: ['$stateParams', 'CompanyCategoryService', function ($stateParams, CompanyCategoryService) {
    if ($stateParams.categoryId) {
      return CompanyCategoryService.get({
        companyId: $stateParams.companyId,
        categoryId: $stateParams.categoryId
      }).$promise;
    }
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.all-status',
      'publication.list-drafts',
      'publication.drafts'
    ]);
  }]
};
module.exports = CompanyPublicationsListDraftsCtrl;

angular.module('dokiv')
  .controller('CompanyPublicationsListDraftsCtrl', [
    '$scope',
    '$stateParams',
    '$state',
    'publications',
    'currentCategory',
    'priorities',
    'translations',
    CompanyPublicationsListDraftsCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationsListDraftsCtrl.js
// module id = 386
// module chunks = 0